/**
 * SaveProgressCTA.jsx — Bandeau CTA « Créer un compte pour sauvegarder ».
 *
 * S'affiche uniquement pour les visiteurs non connectés qui ont déjà
 * de la progression enregistrée (localStorage). Dismissable.
 *
 * Utilisé sur tous les livrets interactifs (Plateau, Circulation, 125, AM).
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CloudUpload, UserPlus, X } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';

export default function SaveProgressCTA({ done = 0 }) {
  const { user } = useApp();
  const [dismissed, setDismissed] = useState(false);
  if (user || dismissed || done <= 0) return null;
  return (
    <div className="bg-gradient-to-r from-rose-950/40 via-rose-900/20 to-transparent border-b border-rose-500/20 print:hidden" data-testid="livret-cta-signup">
      <div className="max-w-4xl mx-auto px-3 sm:px-6 py-2.5 flex items-center gap-3">
        <CloudUpload className="w-5 h-5 text-rose-300 flex-shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-white text-[13px] font-bold leading-tight">Ta progression est enregistrée sur cet appareil</div>
          <div className="text-white/60 text-[11.5px] leading-tight">Crée un compte gratuit pour la retrouver sur tous tes appareils.</div>
        </div>
        <Link to="/register" className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg bg-rose-600 hover:bg-rose-500 text-white text-[11px] font-black uppercase tracking-widest transition flex-shrink-0" data-testid="livret-cta-register-btn">
          <UserPlus className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Créer un compte</span><span className="sm:hidden">Compte</span>
        </Link>
        <button onClick={() => setDismissed(true)} className="w-7 h-7 rounded-lg hover:bg-white/10 flex items-center justify-center flex-shrink-0" aria-label="Fermer" data-testid="livret-cta-dismiss">
          <X className="w-3.5 h-3.5 text-white/50" />
        </button>
      </div>
    </div>
  );
}
